import { ApolloQueryResult } from 'apollo-client';
import { keys } from 'lodash';

import { PlacementsMapHelpers } from '../service/PlacementsMap/PlacementsMap';
import { PredictorHelpers } from '../service/PredictorHelpers/PredictorHelpers';
import { DisplayListItem, DisplayPageBlock, Screen } from '../typings/displayMap';
import { GdPageBlockInput, GroupBannersQuery } from '../typings/graphql-grid';
import { BannerSize } from '../typings/predictor';

export function mapSizeBannersFromApiFormats(result: ApolloQueryResult<GroupBannersQuery>): BannerSize[] | undefined {
    const rowset = result.data.client.ads.rowset;

    return rowset
        ? rowset.reduce((res: BannerSize[], banner) => {
              if (banner.creative) {
                  const { width, height } = banner.creative;
                  const creative = banner.typedCreative;
                  let isAdaptive = false;
                  let isAspect = false;

                  if (creative && creative.__typename === 'GdCanvasCreative') {
                      isAdaptive = Boolean(creative.isAdaptive);
                  }

                  if (creative && creative.__typename === 'GdCpmVideoCreative' && creative.moderationInfo) {
                      const { aspects } = creative.moderationInfo;

                      if (aspects && aspects.length) {
                          isAspect = true;

                          aspects.forEach((videoCreative: BannerSize) => {
                              const bannerVideoSize = PredictorHelpers.checkBannerSizeIsUnique(res, {
                                  width: videoCreative.width,
                                  height: videoCreative.height,
                                  isAspect
                              });

                              if (bannerVideoSize) {
                                  res.push(bannerVideoSize);
                              }
                          });
                      }
                  } else {
                      const bannerSize = PredictorHelpers.checkBannerSizeIsUnique(res, {
                          width: width || undefined,
                          height: height || undefined,
                          isAdaptive
                      });

                      if (bannerSize) {
                          res.push(bannerSize);
                      }
                  }
              }
              return res;
          }, [])
        : undefined;
}

export function mapPageBlocksToApiFormats(pageBlocks?: DisplayPageBlock[]): GdPageBlockInput[] | undefined {
    if (!pageBlocks) {
        return;
    }

    return pageBlocks.reduce((res: GdPageBlockInput[], pageBlock) => {
        const { pageId, impId } = pageBlock;

        if (!impId || !pageId) {
            return res;
        }

        const index = res.findIndex(item => pageId === item.pageId);

        if (index !== -1) {
            let { blockIds } = res[index];

            if (!blockIds) {
                blockIds = [];
            }
            blockIds.push(impId);
        } else {
            res.push({
                blockIds: [impId],
                pageId
            });
        }

        return res;
    }, []);
}

export function mapAllPageBlocksToApiFormat(screenGroupsByRegion?: {
    [id: string]: DisplayListItem[];
}): GdPageBlockInput[] | undefined {
    if (!screenGroupsByRegion) {
        return;
    }

    const res: GdPageBlockInput[] = [];

    keys(screenGroupsByRegion).forEach((regionId: string) => {
        screenGroupsByRegion[regionId].forEach((group: DisplayListItem) => {
            group.screens.forEach((screen: Screen) => {
                const { pageId, impId } = PlacementsMapHelpers.parsePageBlockId(screen.id);

                const index = res.findIndex(item => pageId === item.pageId);

                if (index !== -1) {
                    let { blockIds } = res[index];

                    if (!blockIds) {
                        blockIds = [];
                    }

                    blockIds.push(impId);
                } else {
                    res.push({
                        blockIds: [impId],
                        pageId
                    });
                }
            });
        });
    });
    return res;
}
